

















import { Component, Watch, Vue } from 'vue-property-decorator';
import Footer from '@/components/Footer.vue';
import Navivation from '@/components/Navigation.vue';

@Component({
  components: {
    Navivation,
    Footer
  },
})
export default class App extends Vue {
  siteBackground: string = ""

  @Watch('$route', { immediate: true, deep: true })
  onUrlChange(route: any) {
    console.log('onUrlChange', route)
    switch (route.name) {
      case 'ndtimer':
        this.siteBackground = 'background-ndtimer'
        break;
      case 'home':
        this.siteBackground = 'background-home'
        break;
      case 'statement':
        this.siteBackground = 'background-statement'
        break;
      case 'work':
        this.siteBackground = 'background-work'
        break;
      case 'forecast':
        this.siteBackground = 'background-forecast'
        break;

      default:
        this.siteBackground = ''
        break;
    }
  }

}
